import React from 'react';

import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useAutoTranslation } from 'src/hooks/useTranslate';
import { Grid } from '@mui/material';

const Root = styled(MuiDialogTitle)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2)
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: 'inherit'
}));

const TitleWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 10
});

const DialogTitle = (props) => {
  const { icon, title, onCloseProps, ...other } = props;
  return (
    <Root {...other}>
      <TitleWrapper>
        <div style={{ marginTop: 5 }}>{icon}</div>
        <Typography variant="h6"> {title} </Typography>
      </TitleWrapper>
      <CloseButton aria-label="close" {...onCloseProps} size="large">
        <CloseIcon />
      </CloseButton>
    </Root>
  );
};

const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(1),
  gap: 15,
  justifyContent: 'flex-start'
}));

const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(2)
}));

const CustomTooltip = ({
  continuous,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  index,
  isLastStep,
  step,
  tooltipProps
}) => {
  const {
    content,
    hideBackButton,
    locale,
    showSkipButton,
    title,
    icon,
    styles
  } = step;
  const { back, close, last, next, skip, start } = locale;
  const output = {
    primary: close
  };

  if (continuous) {
    if (isLastStep) {
      output.primary = last;
    } else {
      if (index > 0) output.primary = next;
      else output.primary = start;
    }
  }

  if (showSkipButton && !isLastStep) {
    output.skip = (
      <Button variant="outlined" {...skipProps}>
        {skip}
      </Button>
    );
  }

  if (!hideBackButton && index > 0) {
    output.back = (
      <Button variant="outlined" {...backProps}>
        {back}
      </Button>
    );
  }

  // translation
  const t = useAutoTranslation();

  return (
    <div key="JoyrideTooltip" style={styles.tooltip} {...tooltipProps}>
      <div style={styles.tooltipContainer}>
        <DialogTitle
          id="p-dialog"
          onCloseProps={closeProps}
          title={t(title)}
          icon={icon}
        />

        {content && <DialogContent dividers>{content}</DialogContent>}
      </div>
      <div style={styles.tooltipFooter}>
        {output.skip}
        {output.back}

        <DialogActions>
          <Button color="secondary" variant="contained" {...primaryProps}>
            {t(output.primary)}
          </Button>
        </DialogActions>
      </div>
    </div>
  );
};

export default CustomTooltip;
